import React from 'react';
var BadPlugin = function () { return (React.createElement("div", null, "Bad plugin config, this should never happen.")); };
BadPlugin.displayName = 'BadPlugin';
export default BadPlugin;
//# sourceMappingURL=BadPlugin.js.map